// This seems to hold matched search strings that components can use to highlight matches in their content
// I'm not sure it actually needs to exist
import { createContext } from 'react';

export const MyContext = createContext<any>({});
